export default "__VITE_ASSET__BnSKnI9X__"